import { EventTriggerType, Trigger } from '../../domain';
import { TriggerExternalLinkDetail } from './components/TriggerExternalLinkDetail';
import { TriggerType } from './components/TriggerType';

interface Props {
  trigger: Trigger;
  triggerType: EventTriggerType;
}

const getGalxePath = (questId?: string) => `https://app.galxe.com/quest/Recall/${questId}`;

export default function GalxeTriggerDetails({ trigger, triggerType }: Props) {
  return (
    <div className="tw:flex tw:flex-row tw:gap-6">
      <TriggerType eventType={triggerType} />
      <TriggerExternalLinkDetail
        label="Quest ID"
        value={trigger.context?.quest_id || 'N/A'}
        href={getGalxePath(trigger.context?.quest_id)}
      />
    </div>
  );
}
